export default __webpack_public_path__ + "static/media/keyur_diwan_resume.a4005312.pdf";